<template>
    <div class="welcome">
      <el-collapse v-model="activeName" accordion style="width: 50%">
          <el-collapse-item :title="'版本号：'+item.versionNum + '  更新日期：' + item.updateNum" v-for="(item, index) in versionArr" :key="index" :name="index+1">
              <div class="content-box">
                    <div style="flex: 1">
                        <div v-for="(child, index) in item.content" :key="index">
                            <span v-if="child.indexOf('-mobile-') > -1">
                                司机端操作指引：<a :href="child">{{child}}</a>
                            </span>
                            <span v-else-if="child.indexOf('-pc-') > -1">
                                pc端操作指引：<a :href="child">{{child}}</a>
                            </span>
                            <span v-else>{{child}}</span>
                        </div>
                    </div>
                    <div class="version-btn-column" v-if="userType == 3">
                        
                        <a class="btn-box" :href="item.src1" target="_blank" v-if="item.src1">
                            <img class="btn-img" src="../assets/img/hhypc/examine.png" alt="" srcset="">
                            <div>托运端操作</div>
                        </a>
                        <span v-else></span>
                        <a class="btn-box" :href="item.src3" target="_blank" style="margin-left: 20px" v-if="item.src3">
                            <img class="btn-img" src="../assets/img/hhypc/examine.png" alt="" srcset="">
                            <div>移动端操作</div>
                        </a>
                        <span class="btn-box-empty" v-else style="margin-left: 20px">
                            <img class="btn-img" src="../assets/img/hhypc/examine.png" alt="" srcset="">
                            <div>移动端操作</div>
                        </span>
                        
                    </div>
                    <div class="version-btn" v-else>
                        <div class="opt-row">
                            <a class="btn-box" :href="item.src" target="_blank" v-if="item.src">
                                <img class="btn-img" src="../assets/img/hhypc/examine.png" alt="" srcset="">
                                <div>运营端操作</div>
                            </a>
                            <span class="btn-box-empty" v-else style="margin-top: 10px">
                                <img class="btn-img" src="../assets/img/hhypc/examine.png" alt="" srcset="">
                                <div>运营端操作</div>
                            </span>
                            <a class="btn-box" :href="item.src1" target="_blank" style="margin-top: 10px;" v-if="item.src1">
                                <img class="btn-img" src="../assets/img/hhypc/examine.png" alt="" srcset="">
                                <div>托运端操作</div>
                            </a>
                            <span class="btn-box-empty" v-else style="margin-top: 10px">
                                <img class="btn-img" src="../assets/img/hhypc/examine.png" alt="" srcset="">
                                <div>托运端操作</div>
                            </span>
                        </div>
                        <div class="opt-row" style="margin-left: 20px">
                            <a class="btn-box" :href="item.src2" target="_blank" v-if="item.src2">
                                <img class="btn-img" src="../assets/img/hhypc/examine.png" alt="" srcset="">
                                <div>承运端操作</div>
                            </a>
                            <span class="btn-box-empty" v-else style="margin-top: 10px">
                                <img class="btn-img" src="../assets/img/hhypc/examine.png" alt="" srcset="">
                                <div>承运端操作</div>
                            </span>
                            <a class="btn-box" :href="item.src3" v-if="item.src3" target="_blank" style="margin-top: 10px">
                                <img class="btn-img" src="../assets/img/hhypc/examine.png" alt="" srcset="">
                                <div>移动端操作</div>
                            </a>
                            <span class="btn-box-empty" v-else style="margin-top: 10px">
                                <img class="btn-img" src="../assets/img/hhypc/examine.png" alt="" srcset="">
                                <div>移动端操作</div>
                            </span>
                        </div>
                    </div>
              </div>
          </el-collapse-item>
      </el-collapse>
      <div class="version-background">
          <img class="version-img" src="../assets/img/hhypc/versionBackground.png" alt="" srcset="">
      </div>
    </div>
  </template>
  
  
  <script>
  export default {
    data() {
      return {
          activeName: 1,
          versionArr: [
            {versionNum: 'wnq20260727', updateNum: '2026年07月27日', src1:"",src:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-260727/wnq-运营-260727.docx",src2:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-260727/wnq-承运-260727.docx",src3:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-260727/wnq-移动-260727.docx", content: ['1、万年青APP新增查询条件，以及页面刷新机制调整；','2、司机APP接单逻辑优化；','3、承运合同，合同号可编辑，并将修改后的合同编号同步到对应的货源中；','4、货源司机单价及固定价格的修改功能优化；','5、已审核完成运单变为无效运单的操作权限下放','6、用户手册显示逻辑；','7、合同到期后授信权限保留；','8、新建/编辑/查看承运商合同，隐藏不必要的字段；']},
            {versionNum: 'wnq20251204', updateNum: '2025年12月04日', src1:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-251204/wnq-托运-251204.docx",src:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-251204/wnq-运营-251204.docx",src2:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-251204/wnq-承运-251204.docx", content: ['1、发货管理优化：修改货源不变风险单、增加”运费计算标准”','2、运单管理优化：新增”磅差”、导出去掉时间限制','3、结算管理优化：新增无效运单查询',]},
            {versionNum: 'wnq20250910', updateNum: '2025年09月10日', src1:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-250910/wnq-托运-250910.docx",src:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-250910/wnq-运营-250910.docx",src2:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-250910/wnq-承运-250910.docx",src3:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-250910/wnq-移动-250910.docx", content: ['1、发货管理优化','2、结算管理优化','3、企业认证优化','4、近期需求相关优化']},
            {versionNum: 'wnq20250321', updateNum: '2025年03月21日', src1:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-250321/wnq-托运-250321.docx",src:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-250321/wnq-运营-250321.docx",src2:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-250321/wnq-承运-250321.docx",src3:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-250321/wnq-移动-250321.docx", content: ['1、发货管理优化','2、运单管理优化','3、司机端App二维码接单优化','4、近期需求相关优化']},
            {versionNum: 'wnq20240930', updateNum: '2024年09月30日', src1:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-240930/wnq-托运-240930.docx",src:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-240930/wnq-运营-240930.docx",src2:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-240930/wnq-承运-240930.docx",src3:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-240930/wnq-移动-240930.docx", content: ['1、司机端货源管理，排序规则优化','2、司机端根据司机定位推送消息','3、司机e签宝上线及托运公司未认证不影响业务流程','4、司机端货源详情和运单详情页，装卸货地址后新增导航图标','5、驾驶舱，未支付数据分别显示司机结算和司机结算2.0已结算未支付数据','6、司机端对上传文件进行压缩处理',]},
            {versionNum: 'wnq20240511', updateNum: '2024年05月11日', src1:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-240511/wnq-托运-240511.docx",src:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-240511/wnq-运营-240511.docx",src2:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-240511/wnq-承运-240511.docx",src3:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-240511/wnq-移动-240511.docx", content: ['1、运单管理，轨迹查询默认可查询100条，超出后需在企业认证授权中交次数','2、新增区域权限，只可查询到已分配的托运公司数据权限','3、发货管理，新增竟价货源导入和‘编辑’按钮，详情内的不可编辑','4、车辆管理新增‘车辆导出’，可配置。操作记录，审核不通过时展示不通过原因','5、司机端司机变更手机号后，复核状态变为“未复核”','6、货源分享到微信后，点击识别后直接跳转到app对应的货源','7、app和小程序对接语音搜索货源（百度API）','8、司机绑定银行卡走三要素校验，且只可绑定提现到司机本人的银行卡',]},
            {versionNum: 'wnq20240326', updateNum: '2024年03月26日', src1:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-240326/wnq-2403261.docx", content: ['1、驾驶舱新增货源看板和跳转，弹窗趋势分析','2、PC端货源新增电子围栏和发货管理详情页面优化','3、运单优化，包括运单起运到达时间判断和风险单','4、司机结算优化，增加财务打回标识','5、财务报表优化，查询和导出增加油气抵扣逻辑及拆分展示','https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-mobile-2403262.mp4', 'https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-pc-24032601.mp4']},
            {versionNum: 'wnq20231201', updateNum: '2023年12月01日', src:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-231201/wnq-231201.docx", src1:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-231201/wnq-2312011.docx", src2:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-231201/wnq-2312012.docx", content: ['1、驾驶舱新增货源看板和跳转，弹窗趋势分析','2、PC端货源新增电子围栏和发货管理详情页面优化','3、运单优化，包括运单起运到达时间判断和风险单','4、司机结算优化，增加财务打回标识','5、财务报表优化，查询和导出增加油气抵扣逻辑及拆分展示']},
            {versionNum: 'wnq20231117', updateNum: '2023年11月17日', src:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-231117/wnq-231117.docx", src1:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-231117/wnq-2311171.docx", src2:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-231117/wnq-2311172.docx", content: ['1、优化登录需要选择端','2、驾驶舱页面展示优化','3、司机管理审核状态，详细记录操作记录及从业资格证图片识别','4、车辆管理审核状态，详细记录操作记录及道路运输许可证图片识别','5、运单完成状态修改为已支付', '6、企业认证优化，非法人认证需上传委托书']},
            //   {versionNum: 'wnq20231016', updateNum: '2023年10月16日', src:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-231016.pdf",src3:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-2310163.pdf", src1:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-2310161.pdf", src2:"https://hyzg-app.oss-cn-beijing.aliyuncs.com/wnqpdf/wnq-2310162.pdf", content: ['1、PC端配置保证金','2、PC发布竞价货源','3、移动端查看竞价货源','4、移动端充值保证金','5、报价记录','6、移动端消息通知','7、司机履约','8、保证金管理',]},
          ]
      };
    },
    computed: {
        userType() {
            var userInfo = this.$store.state.sharing.userInfo;
            if (!userInfo) {
                userInfo = localStorage.getItem('login');
            }
            return userInfo.userType
        }
    },
    activated(){
      this.activeName = 1; 
    },
    mounted() {
      this.activeName = 1; 
    },
    methods: {
        empty() {
            console.log("!1")
            this.$message.warning("暂无更新内容")
        }
    }
  };
  </script>
  
  <style scoped>
  .welcome {
    margin: 50px;
  }
  .content-box{
      display: flex;
      justify-content: space-between;
  }
  .version-btn{
      display: flex;
      align-items: flex-end;
      flex-direction: row;
      justify-content: center;
      margin-right: 20px;
  }
  .opt-row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .version-btn-column {
        margin-right: 20px;
        display: flex;
        align-items: flex-end;
        flex-direction: row;
        justify-content: center;
    
  }
  .btn-img{
      width: 15px;
      height: 12px;
      margin-right: 5px;
  }
  .btn-box{
      display: flex;
      align-items: center;
      border: 1px solid #316DF4;
      color: #316DF4;
      padding: 0 5px;
      border-radius: 5px;
      font-size: 12px;
      text-decoration:none;
  }
  .btn-box-empty {
    display: flex;
    align-items: center;
    border: 1px solid transparent;
    color: transparent;
    padding: 0 5px;
    border-radius: 5px;
    font-size: 12px;
    text-decoration:none;
    opacity: 0;
  }
  .version-background{
      position: fixed;
      bottom: 30px;
      right: 0;
      width: 50%;
      display: flex;
      justify-content: flex-end;
      z-index: -1;
  }
  .version-img{
      width: 60%;
      height: auto;
  }
  </style>
  


// WEBPACK FOOTER //
// src/page/version.vue